
                import "css-modules://src_components_panel_panel"
                export default {"Main":"_ee30c5","Inner":"_5e605a","Close":"_574df7","Visible":"_a7815e","Icon":"_4742a3","X":"_2c6656","Circle":"_46138d","Bg":"_5408b4"}
            